import { render, staticRenderFns } from "./ManagePlayers.vue?vue&type=template&id=63cb8f5e&"
import script from "./ManagePlayers.vue?vue&type=script&lang=js&"
export * from "./ManagePlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports